import Vue from "vue";
import Vuex from "vuex";
import cfStoreFunction from "@alliedcrowds/capital-finder-vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

const cfStore = cfStoreFunction({
  apiUrl: process.env.API_URL,
  apiKey: process.env.API_KEY,
  resultsPerPage: 1000,
  maxResults: 10000
});

const store = new Vuex.Store({
  plugins: [createPersistedState()],
  modules: {
    cfStore: cfStore
  },
  state: {
    fundingNeed: undefined,
    firstSearch: true,
    selectedSector: undefined,
    selectedCapitalType: undefined,
    selectedProviderType: undefined,
    selectedFemaleFocus: false,
    timeTaken: undefined,
    noResultsDisplayed: 12,
    oldIE: false,
    isLoading: false
  },
  getters: {
    timeTaken: state => {
      return state.timeTaken;
    },
    isLoading: state => {
      return state.isLoading;
    },
    fundingNeed: state => {
      return state.fundingNeed;
    },
    isFirstSearch: state => {
      return state.firstSearch;
    },
    selectedDropdownCapitalType: state => {
      return state.selectedCapitalType;
    },
    selectedDropdownSector: state => {
      return state.selectedSector;
    },
    selectedDropdownProviderType: state => {
      return state.selectedProviderType;
    },
    selectedDropdownFemaleFocus: state => {
      return state.selectedFemaleFocus;
    },
    noResults: state => {
      return state.noResultsDisplayed;
    },
    isOldIE: state => {
      return state.oldIE;
    }
  },
  mutations: {
    setIEValue(state) {
      state.oldIE = true;
    },
    setIsLoading(state, data) {
      state.isLoading = data;
    },
    setFundingNeed(state, data) {
      state.fundingNeed = data;
    },
    setFirstSearch(state, data) {
      state.firstSearch = data;
    },
    setDropdownCapitalType(state, data) {
      state.selectedCapitalType = data;
    },
    setDropdownSector(state, data) {
      state.selectedSector = data;
    },
    setDropdownProviderType(state, data) {
      state.selectedProviderType = data;
    },
    setDropdownFemaleFocus(state, data) {
      state.selectedFemaleFocus = data;
    },
    setTimeTaken(state, data) {
      state.timeTaken = data;
    },
    addMoreResults(state, data) {
      state.noResultsDisplayed += data;
    },
    resetNumberResults(state) {
      state.noResultsDisplayed = 12;
    }
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store.js